export const REG_LETTER_NUMBER = /^[A-Za-z0-9]+$/;
